<script type="text/javascript">
	import { get, writable } from "svelte/store";
	import { onMount, afterUpdate, beforeUpdate, tick } from "svelte";

	import LoadState from "../../../Enums/LoadState";
	import AuthStore from "../../../Auth/Store";

	import ModalWindow from "../../ModalWindow.svelte"
	import CompanyStore from "./Store"

	import DataTable, {Head, Body, Row, Cell} from '@smui/data-table';
	import Tab, { Icon, Label } from '@smui/tab';
  	import TabBar from '@smui/tab-bar';
	import IconButton from "@smui/icon-button";


  	import Form from '../../Admin/Form.svelte';
	import CMSSpinner from "../../Admin/CMSSpinner.svelte";
	import ImageForm from "../../Admin/ImageForm.svelte"
	import ConfirmDialogView from "../../ConfirmDialog/ConfirmDialogView.svelte";
	import VesselCommentsCMSView from "../../VesselComments/CMSView.svelte";

	import MenuItem from "../../FlyoutMenu/MenuItem.svelte"
	import MenuItemTitle from "../../FlyoutMenu/MenuItemTitle.svelte"
	import NavPath from '../../NavPath/NavPath.svelte';
	import NavPathItem from '../../NavPath/Item.svelte';

	import ImageCollection from "../../../Models/ImageCollection";
	import Image from "../../../Models/Image";

	import User from "../../../Branding/User";
	import Feature from "../../../Branding/Feature";



	let modal;
	let generalForm;

	let currentUserResponse = CompanyStore.dashboard.data.currentUser;
	let currentImageCollections = CompanyStore.dashboard.data.imageCollections;
	let currentImages = CompanyStore.dashboard.data.images;

	let vesselCommentThreads = CompanyStore.dashboard.data.vesselCommentThreads;
	let vesselCommentThreadDetails = CompanyStore.dashboard.data.vesselCommentThreadDetails;

	let visible = CompanyStore.dashboard.meta.visible;
	let loadState = CompanyStore.dashboard.meta.loadState;

	$: {
		if ($visible) {
			CompanyStore.dashboard.actions.init();
		}
	};
	$: if (generalForm) generalForm.setReadOnly(false); //$loadState === LoadState.LOADING);

	let tabs = []
	let activeTab = writable();

	let updateTabs = (forceTabReset = false) => {
		tabs = [];
		tabs.push("General");
		if (User.hasFeature(Feature.IMAGE_ASSETS.EDIT)) {
			tabs.push("Images");
		}
		if (User.hasAnyOfFeatures([Feature.MARITIME.VESSEL_COMMENTS.VIEW, Feature.MARITIME.VESSEL_COMMENTS.EDIT])) {
			tabs.push("Vessel Comments");
		}

		if ($activeTab === "" || forceTabReset) {
			$activeTab = tabs[0];
			tabs = tabs;
		}
	};
	afterUpdate(()=>{
		updateTabs();
	});

	AuthStore.userInfo.subscribe(() => { updateTabs(true); });

	let formatUserLimit = (amount, limit) => {
		return "" + amount + " / " + ((limit === -1)?"Unlimited":limit);
	}

	let editingImage = writable(null);
	let setEditingImage = (image) => {
 		$editingImage = image;
 		console.log('editing image', image);
 		if (modal) modal.scrollToTop()
	};
	let clearEditing = () => {
		$editingImage = null;
		if (modal) modal.scrollToTop();
	};

	let canAddOrEdit = false;
	$: {
		$visible;
		canAddOrEdit = User.hasFeature(Feature.IMAGE_ASSETS.EDIT);
	}
</script>

<ModalWindow
	materialIcon={"business"}
	title={`Company Dashboard`}
	hasCloseButton={true}
	resizable={false}
	draggable={false}
	fullscreen={true}
	padding={false}
	bind:open={$visible}
	bind:this={modal} >

	{#if $loadState === LoadState.LOADING}

		<CMSSpinner/>

	{:else if $loadState === LoadState.LOADED}

		<TabBar tabs={tabs} let:tab bind:active={$activeTab} class="border-shadow">
			<Tab {tab} minWidth><Label>{tab}</Label></Tab>
		</TabBar>
		<div class='tab-content'>

			{#if $activeTab == "General"}

				<Form bind:this={generalForm} id='company-form'>
					<MenuItemTitle title={"General Information"} materialIcon={"info"}/>

					<DataTable table$aria-label="General Information">
						<Head>
							<Row>
								<Cell></Cell>
								<Cell></Cell>
							</Row>
						</Head>
						<Body>
							<!-- <Row>
								<Cell style="width:20%;">Company Name</Cell>
								<Cell>
									{$currentUserResponse.company.name}
								</Cell>
							</Row> -->
							<Row>
								<Cell>Access Tier</Cell>
								<Cell>
									{$currentUserResponse.tier.name}
								</Cell>
							</Row>
							<Row>
								<Cell>Users</Cell>
								<Cell>
									{$currentUserResponse.company.user_count}
									<!-- {formatUserLimit($currentUserResponse.company.user_count, $currentUserResponse.tier.user_limit)} -->
								</Cell>
							</Row>
							<Row>
								<Cell>Alerts</Cell>
								<Cell>
									{#each $currentUserResponse.alert_types as alertType (alertType.id)}
										<div class='fl m-3'><span class='shortcode' title={alertType.name}>{alertType.code}</span></div>
									{/each}
								</Cell>
							</Row>
						</Body>
					</DataTable>

				</Form>

			{:else if $activeTab == "Images"}

				{#if $editingImage === null}
					<MenuItemTitle title={"Images"} materialIcon={"insert_photo"}>
						<slot name='context-menu'>
							{#if canAddOrEdit}
								<IconButton class="material-icons" on:click={()=>{ setEditingImage(new Image({})); }}>add</IconButton>
							{/if}
						</slot>
					</MenuItemTitle>

					<DataTable table$aria-label="Images">
						<Head>
							<Row>
								<Cell>Name</Cell>
								<Cell>File</Cell>
								<Cell>Type</Cell>
								<Cell>Size</Cell>
							</Row>
						</Head>
						<Body>
							{#each $currentImages as image}
								<Row>
									<Cell><a href="/" on:click={(e)=>{ e.preventDefault(); setEditingImage(image); }}>{image.name}</a></Cell>
									<Cell>{image.fileName}</Cell>
									<Cell>{image.fileType}</Cell>
									<Cell>{image.readableSize}</Cell>
								</Row>
							{/each}
							{#if $currentImages.length === 0}
								<Row>
									<Cell colspan='4'>No Image Assets</Cell>
								</Row>
							{/if}
						</Body>
					</DataTable>
				{:else if $editingImage !== null}
					<NavPath>
						<NavPathItem materialIcon={"insert_photo"}></NavPathItem>
						<NavPathItem link on:click={clearEditing}>Images</NavPathItem>
						<NavPathItem spacer/>
						<NavPathItem>{($editingImage.isNew()?"New":$editingImage.name)}</NavPathItem>
					</NavPath>
					<ImageForm
						image={$editingImage}
						endpointNew={"images/create-in-company"}
						endpointExisting={"images/{image_id}"}
						confirmDialog={CompanyStore.dashboard.confirmDialog}
						canSubmit={canAddOrEdit}
						on:added={(e)=>{
							$currentImages = [...$currentImages, e.detail.image];
							//AdminStore.actions.addImage(e.detail.image);
						}}
						on:submit={(e)=>{
							if (e.detail.returnToMenu) {
								clearEditing();
								return;
							}
							$editingImage = e.detail.image;
						}}
						on:delete={(e)=>{
							let index = $currentImages.indexOf(e.detail.image);
							$currentImages.splice(index, 1);
							$currentImages = $currentImages;
							clearEditing();
						}}
						/>
				{/if}

			{:else if $activeTab == "Vessel Comments"}
				
				<VesselCommentsCMSView threads={vesselCommentThreads} threadsDetails={vesselCommentThreadDetails} confirmDialog={CompanyStore.dashboard.confirmDialog} />

			{/if}

		</div>
	{/if}
</ModalWindow>

<ConfirmDialogView data={CompanyStore.dashboard.confirmDialog} />